import React from 'react';
import PropTypes from 'prop-types';
import MarketShare from 'components/partials/charts/ShareChart';
import {
  transformPieChartData,
  transformPieChartForBoxes,
  generateStationGroup,
  removeDuplicated
} from '../ProductionDashboardHelpers';

export default function ThroughputTab({ productionItems, ancillaryItems, hardwareItems }) {
  return (
    <div>
      <h3>Throughput</h3>
      <div className="charts-grid">
        {productionItems && productionItems.length > 0 &&
          productionItems.map((station, ind) => (
            <div key={ind}>
              <MarketShare
                data={transformPieChartData(station.value, 'stationName')}
                radius={['95%', '83%']}
                title={generateStationGroup(station.key)}
                summary={
                  station.key === 'sashAssembly'
                    ? removeDuplicated(station.value)?.length
                    : ''
                }
              />
            </div>
          ))}

        {ancillaryItems && ancillaryItems.length > 0 && (
          <MarketShare
            data={transformPieChartForBoxes(ancillaryItems, 'stationName')}
            radius={['95%', '83%']}
            title={'Ancillaries'}
            summary={ancillaryItems.filter(b => !b.isBox)?.length}
          />
        )}

        {hardwareItems && hardwareItems.length > 0 && (
          <MarketShare
            data={transformPieChartForBoxes(hardwareItems, 'stationName')}
            radius={['95%', '83%']}
            title={'Hardwares'}
            summary={hardwareItems.filter(b => !b.isBox)?.length}
          />
        )}
      </div>
    </div>
  );
}

ThroughputTab.propTypes = {
  productionItems: PropTypes.array.isRequired,
  ancillaryItems: PropTypes.array.isRequired,
  hardwareItems: PropTypes.array.isRequired
};
